const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLift2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "\\u0428\\u0430\\u0440 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.65,
    height: 60.42,
    viewBox: "0 0 57.65 60.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "\\u0428\\u0430\\u0440 6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: 15.67,
    x2: 42.25,
    y2: 0.75,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "56.9 59.67 2.75 59.67 2.75 45.26",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.75,36.67l-15.48-6.38c-.97-.4-2.05-.38-3,.06L.75,37.51",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.75,
    y1: 55.67,
    x2: 32.75,
    y2: 36.28,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.9,33.76l-11.05-18.03c-1.71-2.8-5.37-2.72-7,.14l-10.1,17.79",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.87,21.12l1.98.45c.59.13,1.12.48,1.53,1l1.61,2.05c1.03,1.31,2.75,1.42,3.89.25l1.09-1.11c.51-.52,1.15-.8,1.82-.81h2.31",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.55,36.01l4.2,7.61-2.02-.76c-.61-.23-1.29-.1-1.79.35h0c-.7.62-1.68.62-2.37,0h0c-.51-.45-1.18-.58-1.79-.35l-2.02.76,4.2-7.61c.37-.67,1.22-.67,1.59,0Z",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.75,
    y: 35.67,
    width: 4,
    height: 4,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.69,43.67l-2.84,3.86c-.32.44.14.99.7.84l2.23-.61c.19-.05.41-.02.57.1l1.66,1.18c.19.14.46.16.67.06l2.72-1.29c.17-.08.37-.09.55-.01l1.92.79c.53.22,1.08-.29.81-.76l-2.35-4.15",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.56,48.49l-3.51,4.36c-.4.49.18,1.12.86.95l2.76-.69c.24-.06.5-.02.7.11l2.05,1.33c.24.15.56.18.83.06l3.35-1.45c.21-.09.46-.1.68-.01l2.37.9c.66.25,1.33-.32,1-.85l-2.9-4.69",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.34,
    y1: 59.32,
    x2: 46.26,
    y2: 54.6,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.75,
    y1: 41.22,
    x2: 2.75,
    y2: 36.59,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7.75 48.67 7.75 43.49 11.45 43.49 11.45 48.67",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15.75 48.67 15.75 43.49 19.45 43.49 19.45 48.67",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "23.65 48.88 23.65 43.7 27.35 43.7 27.35 48.88",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.75,
    y1: 49.3,
    x2: 32.75,
    y2: 49.3,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7.7 58.82 7.7 54.67 11.4 54.67 11.4 58.82",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15.7 58.82 15.7 54.67 19.4 54.67 19.4 58.82",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "23.6 58.99 23.6 54.84 27.3 54.84 27.3 58.99",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.45,
    y1: 12.09,
    x2: 11.45,
    y2: 23.72,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.75,
    y1: 23.67,
    x2: 15.42,
    y2: 23.67,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.86,
    y1: 6.4,
    x2: 27.86,
    y2: 18.03,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.16,
    y1: 17.98,
    x2: 31.83,
    y2: 17.98,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLift2);
export default __webpack_public_path__ + "static/media/lift2.4347fc11d5a850f4fa4658867a70e465.svg";
export { ForwardRef as ReactComponent };